import { render, staticRenderFns } from "./reject-form.vue?vue&type=template&id=6be4b2ca"
import script from "./reject-form.vue?vue&type=script&lang=js"
export * from "./reject-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports